<div>
    <img src="/assets/images/no-access.svg" />
    <h2>{{ "dtmUi.notAuthorizedMessage" | transloco }}</h2>
</div>
